import React from 'react';
import PropTypes from 'prop-types';
// import { generateAppPath } from 'epic-common/src/route';

class DiscussBlock extends React.Component {
    static propTypes = {
        gunGirl: PropTypes.string,
        bgImage: PropTypes.string,
        subTitle1: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        buttonText1: PropTypes.string,
        buttonLink1: PropTypes.string
    }

    render() {
        // const homeLink = generateAppPath('/home');
        const {
            gunGirl, bgImage, subTitle1, title, buttonText1, description, buttonLink1
        } = this.props;
        const style = {
            backgroundImage: `url(${gunGirl})`
        };

        return (
            <section className="discuss">
                <div className="grid" style={style}>
                    <img alt="background" src={bgImage} className="ipad hide-tablet-down" />
                    <div className="headline">{title}</div>
                    <div className="copy">
                        <h3>{subTitle1}</h3>
                        <p>{description}</p>
                        <a href={buttonLink1} className="btn alt forum">{buttonText1}</a>
                    </div>
                </div>
            </section>
        );
    }
}

export default DiscussBlock;
